









import { Component, Vue } from 'vue-property-decorator'
@Component({ name: 'PageLayout' })
export default class PageLayout extends Vue {}
